/**
 * @generated SignedSource<<968c2c631a6dd4efd67014d0778d16a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MATPremiumTypeEnum = "premium_non_refundable" | "premium_refundable" | "%future added value";
export type MATInternalPremiumApplyHistoryCreateInput = {
  endAt: any;
  itemName: string;
  premiumType: MATPremiumTypeEnum;
  startAt: any;
  userId: string;
};
export type PremiumCreateDialog_premiumCreateMutation$variables = {
  input: MATInternalPremiumApplyHistoryCreateInput;
};
export type PremiumCreateDialog_premiumCreateMutation$data = {
  readonly internalPremiumApplyHistoryCreate: {
    readonly created: any;
    readonly endAt: any | null;
    readonly id: string;
    readonly item: {
      readonly id: string;
      readonly name: string;
      readonly premiumType: MATPremiumTypeEnum;
    };
    readonly startAt: any;
    readonly user: {
      readonly id: string;
    };
  };
};
export type PremiumCreateDialog_premiumCreateMutation = {
  response: PremiumCreateDialog_premiumCreateMutation$data;
  variables: PremiumCreateDialog_premiumCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MATPremiumApplyHistory",
    "kind": "LinkedField",
    "name": "internalPremiumApplyHistoryCreate",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "created",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MATInternalItem",
        "kind": "LinkedField",
        "name": "item",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "premiumType",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MATInternalUser",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PremiumCreateDialog_premiumCreateMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PremiumCreateDialog_premiumCreateMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "73c9236e2733b803ac68c54281215973",
    "id": null,
    "metadata": {},
    "name": "PremiumCreateDialog_premiumCreateMutation",
    "operationKind": "mutation",
    "text": "mutation PremiumCreateDialog_premiumCreateMutation(\n  $input: MATInternalPremiumApplyHistoryCreateInput!\n) {\n  internalPremiumApplyHistoryCreate(input: $input) {\n    id\n    startAt\n    endAt\n    created\n    item {\n      id\n      name\n      premiumType\n    }\n    user {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b87288c6fe73791d31041cd78adfab55";

export default node;
